import type { AnyAction } from 'redux';

import { RootState } from 'store/configureStore';

import * as types from './actionTypes';

type BulkEditQuantitesDrawerState = {
  isOpen: boolean;
  quoteItemIds: number[];
};

const initialState: BulkEditQuantitesDrawerState = {
  isOpen: false,
  quoteItemIds: [],
};

export const reducer = (state = initialState, action: AnyAction) => {
  const { payload, type } = action;
  switch (type) {
    case types.OPEN:
      return {
        ...state,
        isOpen: true,
        quoteItemIds: payload.quoteItemIds,
      };
    case types.CLOSE:
      return {
        ...state,
        isOpen: false,
        quoteItemIds: [],
      };
    default:
      return state;
  }
};

const getScope = (state: RootState): BulkEditQuantitesDrawerState =>
  state.modules.quotes.quoteItemNav.bulkEditQuantitiesDrawer;

export const getIsOpen = (state: RootState) => getScope(state).isOpen;

export const getQuoteItemIds = (state: RootState) =>
  getScope(state).quoteItemIds;
